module.exports = __webpack_public_path__ + "img/cn.1276b097.png";